import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { odcUrls } from "../../URL/ApplicationUrls";
import Odc, { removeHandlingTimesForSubTypes } from "../Odc";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useUpdateOdc = (odcId: number | string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (odc: Odc) => {
      return axios.put<Odc>(odcUrls.updateOdc.apiUrl, removeHandlingTimesForSubTypes(odc));
    },
    onSuccess: async (response: AxiosResponse<Odc>) => {
      const odc = response.data;
      await queryClient.invalidateQueries(namedQueryKeyWithId("odcs", odc.Id));
      toast.success(`Updating the ODC with the Id ${odc.Id} was successful`);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
